import revive_payload_client_4sVQNw7RlN from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import a_dayjs_QXIUlNDrhZ from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/a.dayjs.ts";
import a_i18n_7JbzjkIb3z from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/a.i18n.ts";
import ant_s6ohUSP3xX from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/ant.ts";
import api_GFfDXud5Cr from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/api.ts";
import clamp_9DaV7PLvq4 from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/clamp.ts";
import domPurify_EH81Bvqh2Y from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/domPurify.ts";
import resizeDirective_3NHAiUvPOR from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/resizeDirective.ts";
import state_gr0cax6cpJ from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/state.ts";
import t_sentry_client_6N1anOkmE6 from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/t.sentry.client.ts";
import tele_UGcJw8bDiQ from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/plugins/tele.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  a_dayjs_QXIUlNDrhZ,
  a_i18n_7JbzjkIb3z,
  ant_s6ohUSP3xX,
  api_GFfDXud5Cr,
  clamp_9DaV7PLvq4,
  domPurify_EH81Bvqh2Y,
  resizeDirective_3NHAiUvPOR,
  state_gr0cax6cpJ,
  t_sentry_client_6N1anOkmE6,
  tele_UGcJw8bDiQ
]